import React from 'react';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { colors } from '../../../themes/typography';
import { UNITS_RAMP } from '../hooks/useHeatmapColors';

const UNITS_GRADIENT = `linear-gradient(90deg, ${UNITS_RAMP.map(([stop, rgb]) => `rgb(${rgb.join(',')}) ${stop * 100}%`).join(', ')})`;

const HeatmapLegend = ({ mode, onModeChange, minVal, maxVal, showToggle = true, categoryLegend, period = 30 }) => {
  const { t } = useTranslation();

  // Sales heatmap: square-root scale, so a quarter of the top sits in the middle of the bar
  if (mode === 'units') {
    const labelSx = { position: 'absolute', top: 0, fontSize: '10px', color: colors.text.secondary, whiteSpace: 'nowrap', lineHeight: 1 };
    return (
      <Box
        title={t('machines_heatmapLegendHint')}
        aria-label={t('machines_heatmapLegendHint')}
        sx={{ width: 140, pb: '14px', position: 'relative' }}
      >
        <Box sx={{
          height: 8,
          borderRadius: '4px',
          background: UNITS_GRADIENT,
          boxShadow: 'inset 0 0 0 1px rgba(0,0,0,0.08)'
        }} />
        <Box sx={{ position: 'absolute', left: 0, right: 0, top: '11px' }}>
          <Typography sx={{ ...labelSx, left: 0 }}>0</Typography>
          <Typography sx={{ ...labelSx, left: '50%', transform: 'translateX(-50%)' }}>{(maxVal / 4).toFixed(1)}</Typography>
          {/* The top is the machine's 95th percentile: busier lanes share the darkest color */}
          <Typography sx={{ ...labelSx, right: 0 }}>{`≥${Number(maxVal).toFixed(1)} u/d`}</Typography>
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 2,
      flexWrap: 'wrap'
    }}>
      {/* Category legend: colored swatches with labels */}
      {mode === 'category' && categoryLegend && categoryLegend.length > 0 && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
          {categoryLegend.map((item) => (
            <Box key={item.name} sx={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <Box sx={{
                width: 14,
                height: 14,
                borderRadius: '3px',
                backgroundColor: item.color,
                border: `1px solid ${colors.border.light}`,
                flexShrink: 0
              }} />
              <Typography sx={{ fontSize: '11px', color: colors.text.secondary, whiteSpace: 'nowrap' }}>
                {item.name}
              </Typography>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default React.memo(HeatmapLegend);
